export enum SubStepNames {
  APPLICATION_LOADED = "Application Loaded",
  SUMMARY = "Summary",
  MODELS = "Models",
  SEGMENT = "Segment",
  INTERIOR = "Interior",
}

export const mapToAdobeComponentStructure = {
  Engines: "Engine Model",
  EngineType: "Engine Type",
  Transmissions: "Transmission",
  Sideskirt: "Sideskirts",
  Air_deflectors: "Air deflectors",
  Ext_trim_levels: "Exterior Trim",
  Headlights: "Headlights",
  Cabs: "Cab Model",
  Mirrors: "Mirrors",
  Colors: "Cab Color",
  ColorName: "Cab Color Name",
  ColorCode: "Cab Color Code",
  Chassis: "Axle Type",
  Chassi_type: "Chassis Type",
  Seats: "Seats",
  Dashboard: "Dashboard",
  Int_trim_levels: "Interior Trim",
  Segment: "Segment",
  Model: "Model",
};